import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState, useEffect } from "react";
import styles from "./Login.module.css";
import { useDispatch } from "react-redux";
import { loginWithCode } from "../../redux/actions/user/loginWithCodeAction";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";

const { Title } = Typography;

const LoginWithCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    // Pre-fill email if coming from forgot password page
    if (location.state?.email) {
      form.setFieldsValue({ email: location.state.email });
    }
  }, [location.state, form]);

  const onFinish = async (values) => {
    setLoader(true);
    const resp = await dispatch(loginWithCode(values));
    if (resp.success === "success") {
      setLoader(false);
      if (resp.isRequired) {
        // Redirect to change password page
        navigate("/auth/change-password");
      } else {
        // Redirect to dashboard
        window.location.href = "/dashboard";
      }
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Please enter a valid email and code");
  };

  return (
    <>
      <Row className="card-row" justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <Card bordered={false} className={styles.card} style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
            <Title level={2} className="text-center" style={{ marginBottom: "1rem", marginTop: "0" }}>
              Enter Reset Code
            </Title>
            
            <p style={{ textAlign: "center", color: "#666", marginBottom: "1.5rem" }}>
              Please enter the 6-digit code sent to your email address.
            </p>

            <Form
              form={form}
              name="loginWithCode"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                className="mb-2"
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter your email address" />
              </Form.Item>

              <Form.Item
                className="mb-2"
                label="Code"
                name="code"
                rules={[
                  {
                    required: true,
                    message: "Please input the 6-digit code!",
                  },
                  {
                    pattern: /^\d{6}$/,
                    message: "Code must be 6 digits!",
                  },
                ]}
              >
                <Input 
                  size="large" 
                  placeholder="Enter 6-digit code" 
                  maxLength={6}
                  style={{ letterSpacing: "8px", textAlign: "center", fontSize: "20px", fontWeight: "bold" }}
                />
              </Form.Item>

              <Form.Item className="mt-2">
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={loader}
                  onClick={() => setLoader(true)}
                  block
                >
                  Verify Code
                </Button>
              </Form.Item>

              <Form.Item className="text-center mt-2">
                <Link to="/auth/forgot-password">Resend Code</Link>
                <span style={{ margin: "0 8px" }}>|</span>
                <Link to="/auth/login">Back to Login</Link>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default LoginWithCode;
